import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Form,
  Container,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";

import { Link } from "react-router-dom";

import axios from "axios";

import { Button } from "components";

import nowLogo from "assets/img/hr-logo-full.png";

// import bgImage1 from "assets/img/minibg/bg1.jpg";
// import bgImage2 from "assets/img/minibg/bg2.jpg";
// import bgImage3 from "assets/img/minibg/bg3.jpg";
// import bgImage4 from "assets/img/minibg/bg4.jpg";
// import bgImage5 from "assets/img/minibg/bg5.jpg";
// import bgImage6 from "assets/img/minibg/bg6.jpg";
// import bgImage7 from "assets/img/minibg/bg7.jpg";
// import bgImage8 from "assets/img/minibg/bg8.jpg";
// import bgImage9 from "assets/img/minibg/bg9.jpg";
// import bgImage10 from "assets/img/minibg/bg10.jpg";
// import bgImage11 from "assets/img/minibg/bg11.jpg";
// import bgImage12 from "assets/img/minibg/bg12.jpg";
import Cookies from "universal-cookie";
import FaceDetection from "views/FaceDetection/FaceDetection.jsx";
import CheckIn from "views/CheckIn/CheckIn.jsx";
import { message } from "antd";

const cookies = new Cookies();

// const API = "https://oficina.nadunet.es/api/rest/";
const API = !window.location.host.includes("localhost") ? "https://" + window.location.host + "/api/rest/" : "https://oficina.nadunet.es/api/rest/";
const DO_LOGIN_URL = "user/login";
const LOGIN_URL = "nadulogin_resources/login";
const GET_TOKEN_URL = "user/token";
const DO_LOGOUT_URL = "user/logout";
// const bgs = [
//   bgImage1,
//   bgImage2,
//   bgImage3,
//   bgImage4,
//   bgImage5,
//   bgImage6,
//   bgImage7,
//   bgImage8,
//   bgImage9,
//   bgImage10,
//   bgImage11,
//   bgImage12
// ];
const recuperarPassStyle = {
  textAlign: "center"
};
class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    //if (this.props.mainState.debug) //console.log("########## PROPS LOGIN ###########");
    //if (this.props.mainState.debug) //console.log(props);
    let fields = {
      login: "dniField",
      pass: "passField"
    };
    // let randomBgNumber = this.randomIntFromInterval(0, 11);
    // let randomBg = bgs[randomBgNumber];

    this.state = {
      firstLoad: true,
      fields: fields,
      [fields.login]: "",
      [fields.pass]: "",
      username: "",
      loginError: false,
      isLogging: false,
      // randomBg: randomBg
    };

    this.doLogin = this.doLogin.bind(this);
    this.getLoginButton = this.getLoginButton.bind(this);
    this.handleLoginError = this.handleLoginError.bind(this);
    this.cleanSession = this.cleanSession.bind(this);
    this.miniLogout = this.miniLogout.bind(this);
    this.showLoginError = this.showLoginError.bind(this);
    this.clearCookies = this.clearCookies.bind(this);

    this.clearCookies();
    this.cleanSession();
  }
  componentDidMount() {
  }
  clearCookies() {
    let _cookies = cookies.getAll();
    // console.log("Clearing cookies", _cookies);
    for (var cookieName in _cookies) {
      if (cookieName.toLowerCase().startsWith("sess")) {
        this.cleanSession();
      }
      cookies.remove(cookieName); // Elimina cada cookie
    }
    localStorage.removeItem("token");
  }
  getLoginButton() {
    let loginButton = null;

    if(this.state.isLogging){
      loginButton = 
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>;
    }else{
      loginButton = "Iniciar sesión";
    }

    return loginButton;
  }
  handleChange(field, event) {
    ////////console.log("Field name: " + field);
    ////////console.log("Field value: " + event.target.value);
    this.setState({ [field]: event.target.value });
  }
  showLoginError() {
    var options = {
      place: "tr",
      message: "Credenciales incorrectas",
      type: "danger",
      icon: "now-ui-icons objects_key-25",
      autoDismiss: 3
    };
    this.props.showNotification(options);
  }
  doLogin(option) {
    if (this.state.isLogging && !option) return;

    this.setState({
      isLogging: true
    });
    
    let request = {
      dni: this.state.dniField,
      password: this.state.passField
    };
    
    this.clearCookies();
    let new_axios = new axios.create();
    new_axios.defaults.withCredentials = false;
    new_axios.post(API + LOGIN_URL, request, {withCredentials: false})
      .then(result => {
        let _result = result;
        result = result.data;
        // console.log("################## RESPUESTA LOGIN ################");
        // console.log(result);
        this.setState({
          isLogging: false
        });
        if (!result.ok) {
          message.error(result.error);
        } else {
          this.props.godMode(_result, false, this.state.passField);
        }
      })
      .catch((error) => {
        this.setState({
          isLogging: false
        });
        message.error('Error al iniciar sesión: ' + error.message);
        return;
        // Error 😨
        if (error.response) {
            /*
              * The request was made and the server responded with a
              * status code that falls out of the range of 2xx
              */
            /* //////console.log(error.response.data);
            //////console.log(error.response.status);
            //////console.log(error.response.headers); */

            this.handleLoginError(error.response.status);

            /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
            /*
              * The request was made but no response was received, `error.request`
              * is an instance of XMLHttpRequest in the browser and an instance
              * of http.ClientRequest in Node.js
              */
            /* //////console.log(error.request); */
            this.handleLoginError(666);
            /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
            // Something happened in setting up the request and triggered an Error
            /* //////console.log('Error', error.message); */
            this.doLogin(true);
            this.setState({
              error,
              isLogging: false
            });
        }
        /* //////console.log(error.config); */
      });
  }
  handleLoginError(error) {
    //////console.log("#################### HANDLE ERROR ##################");
    //////console.log(error);
    switch (error) {
      case 401:
        this.cleanSession();
        return this.doLogin(true);
        break;
      case 500:
        return this.doLogin(true);
        break;
      case 666:
        return this.doLogin(true);
        break;
      default:
        break;
    }
  }
  cleanSession() {
    let request = {};
    let newToken = "";

    //this.setState({ isLoading: true });
    axios.post(API + GET_TOKEN_URL, request, {withCredentials: true})
      .then(result => {
        //////console.log("################## RESPUESTA GET TOKEN ################");
        //////console.log(result);
        newToken = result.data.token;
        this.miniLogout(newToken);
      })
      .catch((error) => {
        if (this.state.firstLoad) {
          this.setState({
            firstLoad: false
          });
        } else {
          // Error 😨
          if (error.response) {
              /*
                * The request was made and the server responded with a
                * status code that falls out of the range of 2xx
                */
              //////console.log(error.response.data);
              //////console.log(error.response.status);
              //////console.log(error.response.headers);
  
              this.handleLoginError(error.response.status);
  
              /* this.setState({
                error,
                isLogging: false
              }); */
          } else if (error.request) {
              /*
                * The request was made but no response was received, `error.request`
                * is an instance of XMLHttpRequest in the browser and an instance
                * of http.ClientRequest in Node.js
                */
              //////console.log(error.request);
              this.handleLoginError(666);
              /* this.setState({
                error,
                isLogging: false
              }); */
          } else {
              this.doLogin(true);
              // Something happened in setting up the request and triggered an Error
              //////console.log('Error', error.message);
              // this.setState({
              //   error,
              //   isLogging: false
              // });
          }
        }
        //////console.log(error.config);
      });
  }
  miniLogout(newToken) {
    let request = {};
    let queryHeaders = {
      headers:{
        "X-CSRF-Token": newToken,
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    };
    axios
      .post(API + DO_LOGOUT_URL, request, {
        headers: queryHeaders.headers,
        withCredentials: true
      })
      .then(result => {
        if (this.state.firstLoad) {
          this.setState({
            firstLoad: false
          });
        } else {
          return this.doLogin(true);
        }
      })
      .catch((error) => {
        if (this.state.firstLoad) {
          this.setState({
            firstLoad: false
          });
        } else {
          return this.doLogin(true);
        }
      });
  }
  randomIntFromInterval(min,max) {
      return Math.floor(Math.random()*(max-min+1)+min);
  }
  render() {
    let fields = this.state.fields;
    let loginErrorMessage =    
      <div className="pull-left link footer-link">
        <h6>
            Credenciales incorrectas
        </h6>
      </div>;
      // console.log("this.props.userData", this.props.userData);
    if (this.state.faceLogin) return (
        <div>
          <div className="full-page-content">
            <div className="login-page">
              <FaceDetection
                {...this.props}
                mainState={this.props.mainState}
                userData={this.props.userData} />
            </div>
          </div>
        </div>
      );
    if (this.state.checkin) return (
        <div>
          <div className="full-page-content">
            <div className="login-page">
              <CheckIn
                {...this.props}
                mainState={this.props.mainState}
                userData={this.props.userData} />
            </div>
          </div>
        </div>
      );
    return (
      <div>
        <div className="full-page-content">
          <div className="login-page" id="hr-login">
            <Container>
              <Col xs={12} md={8} lg={4} className="ml-auto mr-auto">
                <Form>
                  <Card className="card-login card-plain">
                    <CardHeader>
                      <div className="logo-container">
                        <img src={nowLogo} alt="now-logo" />
                      </div>
                    </CardHeader>
                    <CardBody>
                      <InputGroup
                        className={
                          "form-control-lg " +
                          (this.state.firstnameFocus ? "input-group-focus" : "")
                        }
                      >
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="now-ui-icons users_circle-08" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          placeholder="DNI"
                          onFocus={e => this.setState({ firstnameFocus: true })}
                          onBlur={e => this.setState({ firstnameFocus: false })}
                          value={this.state[fields.login]}
                          onChange={(e) => this.handleChange(fields.login, e)}
                        />
                      </InputGroup>
                      <InputGroup
                        className={
                          "form-control-lg " +
                          (this.state.lastnameFocus ? "input-group-focus" : "")
                        }
                      >
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="now-ui-icons objects_key-25" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="password"
                          placeholder="Contraseña"
                          onFocus={e => this.setState({ lastnameFocus: true })}
                          onBlur={e => this.setState({ lastnameFocus: false })}
                          value={this.state[fields.pass]}
                          onChange={(e) => this.handleChange(fields.pass, e)}
                        />
                      </InputGroup>
                    </CardBody>
                    <CardFooter className="text-center">
                      <Button
                        block
                        round
                        color={this.state.isLogging ? "default" : "primary"}
                        size="lg"
                        href=""
                        className="mb-3"
                        onClick={() => this.doLogin()}
                      >
                        {this.getLoginButton()}
                      </Button>
                      {/* <Button
                        round
                        block
                        // leftLabel={"now-ui-icons users_circle-08"}
                        color={this.state.isLogging ? "default" : "primary"}
                        size="lg"
                        href=""
                        className="mb-3"
                        onClick={() => this.setState({ faceLogin: true })}
                      >
                        <i className="2x now-ui-icons users_circle-08" />{" "}Reconocimiento facial
                      </Button> */}
                      <Button
                        round
                        block
                        // leftLabel={"now-ui-icons users_circle-08"}
                        color={this.state.isLogging ? "default" : "primary"}
                        size="lg"
                        href=""
                        className="mb-3"
                        onClick={() => this.setState({ checkin: true })}
                      >
                        <i className="2x now-ui-icons business_badge" />{" "}Fichador
                      </Button>
                      {/*<div style={recuperarPassStyle}>
                        <Link to="/recuperar">Recuperar contraseña</Link>
                      </div>*/}
                      {/* this.state.loginError && loginErrorMessage */}
                      {/* <div className="pull-right">
                        <h6>
                          <a href="#pablo" className="link footer-link">
                            Need Help?
                          </a>
                        </h6>
                      </div> */}
                    </CardFooter>
                  </Card>
                </Form>
              </Col>
            </Container>
          </div>
        </div>
        <div
          className="full-page-background"
          // style={{ backgroundImage: "url(" + this.state.randomBg + ")" }}
        />
      </div>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/views/Pages/LoginPage.jsx